import logo from '../logo.svg';
import './Home.css';
import AppSetup from '../components/AppSetup/AppSetup';
import LearninHome from '../components/LearninHome/LearninHome';
import { useSelector } from 'react-redux';
import { AppState, State, UserRole } from '../state';

const Home: React.FC = () => {

  const { role, appState } = useSelector((state: State) => state)
  
  return (
    <div className="Home">
        <div className={`background-container${appState === AppState.Transition ? ' transition' : appState === AppState.NoAnimation ? ' noAnimation' : ''}`}></div>
        <img src={logo} className={`App-logo${appState === AppState.Transition ? ' transition' : appState === AppState.NoAnimation ? ' noAnimation' : ''}`} alt="logo" />
        {role === UserRole.NotSet
          ? <AppSetup className="initial-container" />
          : <LearninHome className={`initial-container${appState === AppState.Transition ? ' transition' : appState === AppState.NoAnimation ? ' noAnimation' : ''}`} />
        }
      </div>
  );
}

export default Home;